import store from '@/store'
import sendRaygun from '@/utils/send-raygun.js'

export default ({ e, routeName, redirectOptions = { name: 'projects' } }) => {
  if (!e) {
    throw new Error('Missing "e"')
  }

  if (!routeName) {
    throw new Error('Missing "routeName"')
  }

  const is404 = e.response?.status === 404
  const is403 = e.response?.status === 403
  const is400 = e.response?.status === 400
  const errorCode = e.response?.data?.error
  const isInvalidObjectIdError = is400 && typeof errorCode === 'string' && (errorCode === 'INVALID_OBJECTID' || errorCode.endsWith(': INVALID_OBJECTID'))
  const isTwoFactorAuthRequiredError = is403 && e.response?.data?.error === 'TWO_FACTOR_AUTH_REQUIRED'

  if (isTwoFactorAuthRequiredError) {
    store.commit('project/SET_SHOW_TWO_FACTOR_AUTH_BLOCKED_SCREEN', true)

    return
  }

  // log 404 because in Planfred there should not exist missing documents
  if (is404) {
    sendRaygun({
      error: new Error(e.response),
      tags: [ '404-async-data-error-handler' ],
    })
  }

  if (is403) {
    sendRaygun({
      error: e,
      tags: [ '403-async-data-error-handler' ],
    })
  }

  if (is404 && routeName === 'projects-projectId') {
    return { name: 'projects' }
  }

  if (is404 || isInvalidObjectIdError || is403) {
    return redirectOptions
  }
}
